import { Database } from 'lucide-react'
import { Link, useLocation } from 'react-router'
import { DatabaseSwitcher } from '@/components/layout/breadcrumbs/database/database-switcher'
import {
  BreadcrumbItem,
  BreadcrumbPage,
  BreadcrumbLink,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb'
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from '@/components/ui/tooltip'
import { useCompanyPath } from '@/lib/hooks'

const DatabasesIconBreadcrumbItem = () => {
  const { getCompanyPath } = useCompanyPath()
  return (
    <BreadcrumbItem>
      <Link to={getCompanyPath({ pathname: '/databases' })}>
        <Tooltip delayDuration={1000}>
          <BreadcrumbPage className="cursor-pointer p-2 flex items-center rounded-md text-muted-foreground hover:bg-muted hover:text-foreground">
            <TooltipTrigger>
              <BreadcrumbLink asChild>
                <div className="cursor-pointer">
                  <Database className="size-3.5" />
                  <span className="sr-only">Databases</span>
                </div>
              </BreadcrumbLink>
            </TooltipTrigger>
          </BreadcrumbPage>
          <TooltipContent sideOffset={8}>
            <span>Databases</span>
          </TooltipContent>
        </Tooltip>
      </Link>
    </BreadcrumbItem>
  )
}

export const DatabaseBreadcrumbs = () => {
  const { pathname } = useLocation()

  return (
    <>
      {pathname === '/databases' ? (
        <BreadcrumbItem>
          <BreadcrumbPage className="flex items-center gap-2 px-2">
            <Database className="size-3.5" />
            <span className="font-medium">Databases</span>
          </BreadcrumbPage>
        </BreadcrumbItem>
      ) : null}
      {pathname === '/databases/create' ? (
        <>
          <DatabasesIconBreadcrumbItem />
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage className="px-2 font-medium">
              Create database
            </BreadcrumbPage>
          </BreadcrumbItem>
        </>
      ) : null}
      {pathname.startsWith('/database/') ? (
        <>
          <DatabasesIconBreadcrumbItem />
          <BreadcrumbSeparator />
          <DatabaseSwitcher />
        </>
      ) : null}
    </>
  )
}
